export class UpdateIdpGroupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "group",
            "baseName": "group",
            "type": "IdpGroup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateIdpGroupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
